import styled from 'styled-components';
import {
  space, color, layout, border, flexbox, position, typography, height, width,
} from 'styled-system';

const Box = styled.div(
  {
    boxSizing: 'border-box',
  },
  space,
  color,
  layout,
  border,
  flexbox,
  position,
  typography,
  height,
  width,
);
export default Box;
